var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3e54",
    d: "M13 27A2 2 0 1 0 13 31A2 2 0 1 0 13 27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M77 12A1 1 0 1 0 77 14A1 1 0 1 0 77 12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fce0a2",
    d: "M50 13A37 37 0 1 0 50 87A37 37 0 1 0 50 13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M83 11A4 4 0 1 0 83 19A4 4 0 1 0 83 11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3e54",
    d: "M87 22A2 2 0 1 0 87 26A2 2 0 1 0 87 22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbcd59",
    d: "M81 74A2 2 0 1 0 81 78 2 2 0 1 0 81 74zM15 59A4 4 0 1 0 15 67 4 4 0 1 0 15 59z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3e54",
    d: "M25 85A2 2 0 1 0 25 89A2 2 0 1 0 25 85Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.5 51A2.5 2.5 0 1 0 18.5 56A2.5 2.5 0 1 0 18.5 51Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M21 66A1 1 0 1 0 21 68A1 1 0 1 0 21 66Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80 33A1 1 0 1 0 80 35A1 1 0 1 0 80 33Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcbbd",
    d: "M29.509,69.3c-0.503,0-1.126-0.145-1.482-1.275c-0.274-0.872-0.273-1.945-0.272-2.655L27.7,37.796 v-3.822c0-1.694,1.321-3.072,2.945-3.072h17.646c1.659,0,3.009,1.455,3.009,3.244v1.459c0,1.244,0.968,2.257,2.157,2.257h16.086 c0.417,0,0.757,0.385,0.757,0.857v23.565c0,0.334,0.013,0.748,0.026,1.214c0.05,1.703,0.131,4.46-0.436,5.802H29.509z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M48.291,31.601c1.273,0,2.309,1.141,2.309,2.544v1.458c0,1.631,1.282,2.957,2.857,2.957 l16.076-0.002c0.011,0.005,0.067,0.053,0.067,0.159v23.566c0,0.339,0.012,0.761,0.026,1.234c0.038,1.287,0.11,3.738-0.236,5.082 h-39.88c-0.266,0-0.568,0-0.815-0.786c-0.242-0.769-0.241-1.777-0.241-2.444l0-0.092L28.4,37.797v-3.824 c0-1.308,1.007-2.372,2.245-2.372H48.291 M48.291,30.201H30.645c-2.005,0-3.645,1.698-3.645,3.772v3.824l0.054,27.484 C27.054,66.704,27,70,29.509,70h40.804C71.368,68.355,71,64.102,71,62.285V38.719c0-0.86-0.652-1.557-1.457-1.557H53.457 c-0.805,0-1.457-0.697-1.457-1.557v-1.458C52,31.977,50.331,30.201,48.291,30.201L48.291,30.201z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M41.5,35h-11c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h11c0.276,0,0.5,0.224,0.5,0.5 S41.776,35,41.5,35z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M48.5,35h-4c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h4c0.276,0,0.5,0.224,0.5,0.5 S48.776,35,48.5,35z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fdfcee",
    d: "M29.478,69.3c-0.608,0-1.106-0.522-1.14-1.179L34.026,42.7h41.92l-5.639,25.369 c-0.011,0.051-0.017,0.102-0.017,0.153c0,0.295-0.106,0.57-0.3,0.775c-0.184,0.194-0.426,0.302-0.681,0.302H29.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M75.074,43.4l-5.45,24.518c-0.022,0.1-0.033,0.203-0.033,0.305c0,0.117-0.042,0.227-0.116,0.301 c-0.05,0.051-0.106,0.076-0.166,0.076H29.478c-0.208,0-0.389-0.191-0.431-0.436L34.587,43.4H75.074 M76.819,42H33.466 l-5.829,26.052c0,1.076,0.824,1.948,1.841,1.948h39.831c0.929,0,1.682-0.796,1.681-1.778L76.819,42L76.819,42z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M50.5,55h-14c-0.154,0-0.299-0.071-0.394-0.192s-0.128-0.279-0.091-0.429l1.5-6 C37.571,48.156,37.771,48,38,48h14c0.154,0,0.299,0.071,0.394,0.192s0.128,0.279,0.091,0.429l-1.5,6 C50.929,54.844,50.729,55,50.5,55z M37.141,54h12.969l1.25-5H38.391L37.141,54z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.0e5626df.svg";
export { ForwardRef as ReactComponent };